/***
 * Created on 2023/9/6
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useEffect} from 'react';
import {useTranslation} from "react-i18next";
import {useTogglePopup} from "../../hook/hooks";
import {
    CHINA,
    convertToQNAPLang,
    getAppCMSUrl, getCurrentDomainRegion,
    getPrivacyPolicyUrl,
    getQNAPUrl,
    getServiceStatusUrl
} from "../../service/common";


function SupportHeader(props) {
    const { t, i18n } = useTranslation();
    const {isShow, toggleAction, elemRef} = useTogglePopup();

    const toggleHeaderSheet = () => {
        const headerSheet = document.querySelector('.comp-sheet-wrapper');
        if (headerSheet?.classList?.contains('hide')) {
            headerSheet.classList.remove('hide');
        }
        else {
            headerSheet?.classList?.add('hide');
        }
    }

    const onMoreAction = () => {
        toggleAction();
        toggleHeaderSheet();
    }

    const onClick = (link) => {
        window.open(link, '_blank');
    }

    useEffect(() => {
        const appHead = document.querySelector('.app-head');
        if (!isShow) {
            appHead.removeAttribute('data-z-index');
        }
        else {
            appHead.setAttribute('data-z-index', 'top');
        }
    }, [isShow])

    return (
        <div className={`util-btn ${isShow ? 'active' : ''}`} ref={elemRef} onClick={onMoreAction} util-type="more" data-testid="support-header">
            <div className="comp-dropdown hide">
                <ul className="dropdown-menu">
                    <li className="dropdown-menu__head">{t('@Support@')}</li>
                    <li className="dropdown-menu__item cursor-pointer" onClick={()=>onClick(`${getAppCMSUrl()}/features?lang=${i18n.language}`)}>{t('@Features@')}</li>
                    <li className="dropdown-menu__item cursor-pointer" onClick={()=>onClick(`${getAppCMSUrl()}/faq?lang=${i18n.language}`, '_blank')}>{t('@FAQ@')}</li>
                    <li className="dropdown-menu__item cursor-pointer" onClick={()=>onClick(`${getServiceStatusUrl()}`)}>{t('@System Status@')}</li>
                    <li className="dropdown-menu__item cursor-pointer" onClick={()=>onClick(`${getQNAPUrl()}/${convertToQNAPLang(i18n.language)}/support-ticket/`)}>{t('@Contact us@')}</li>
                    <li className="dropdown-menu__divider !mt-10 !mb-10"></li>
                    {getCurrentDomainRegion() !== CHINA &&
                        <>
                            <li className="dropdown-menu__head">{t('@Community@')}</li>
                            <li className="dropdown-menu__item cursor-pointer" onClick={()=>onClick(window.acc_mf.common.APP_FORUM_URL)}>{t('@Forum@')}</li>
                            <li className="dropdown-menu__divider !mt-10 !mb-10"></li>
                        </>
                    }
                    <li className="dropdown-menu__head">QNAP</li>
                    <li className="dropdown-menu__item cursor-pointer" onClick={()=>onClick(`${getQNAPUrl()}/${convertToQNAPLang(i18n.language)}`)}>{t('@QNAP official website@')}</li>
                    <li className="dropdown-menu__item cursor-pointer" onClick={()=>onClick(`${getPrivacyPolicyUrl()}}`)}>{t('@Privacy policy@')}</li>
                    <li className="dropdown-menu__item cursor-pointer" onClick={()=>onClick(`${getQNAPUrl()}/${convertToQNAPLang(i18n.language)}/before_buy/con_show.php?op=showone&cid=15`)}>{t('@Terms of service@')}</li>
                    <li className="dropdown-menu__item cursor-pointer" onClick={()=>onClick(`${getAppCMSUrl()}/security?lang=${i18n.language}`)}>{t('@Security Disclaimer@')}</li>
                </ul>
            </div>
        </div>
    );
}

export default SupportHeader;
